import {DscrIndustryEbitda} from '../../const';

export type DscrIndustryEbitdaSelectionValue = DscrIndustryEbitda | null;
